import BlogContainer from "src/container/blog";
import { Helmet } from "react-helmet-async";

const Blog = () => {
  return (
    <>
    <Helmet>
      <title>텔레모아::핵심 텔레그램 채널의 중요 정보를 모아!</title>
      <meta name="description" content="주식시장 방향성 확인의 바로미터, 오늘 꼭 읽어야 하는 블로그 포스팅 모음 공개!" />
    </Helmet>
    <div className="container mt-4">
      <div className="row">
        <BlogContainer rowPerPage={20} />
      </div>
    </div>
    </>
  );
}

export default Blog;
